import { Button } from '@repo/ui/button'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/ui/select'
import { cn } from '@repo/ui/utils'
import * as React from 'react'
import { DayPicker } from 'react-day-picker'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        weekday: 'font-medium text-primary-500 select-none',
        dropdowns: 'flex gap-2 mb-2',
        ...classNames,
      }}
      {...props}
      components={{
        DayButton: (props) => (
          <Button
            variant={
              props.modifiers.selected ? 'default' : props.modifiers.today ? 'secondary' : 'ghost'
            }
            disabled={props.modifiers.selected}
            size="icon"
            {...props}
          >
            {props.day.date.getDate()}
          </Button>
        ),
        Dropdown: (props) => {
          const { options, value, onChange } = props
          const handleValueChange = (newValue: string) => {
            if (props.onChange) {
              const syntheticEvent = {
                target: {
                  value: newValue,
                },
              } as React.ChangeEvent<HTMLSelectElement>

              props.onChange(syntheticEvent)
            }
          }
          if (!options || value === undefined || !onChange) return <></>
          return (
            <Select
              defaultValue={value.toString()}
              value={value.toString()}
              onValueChange={handleValueChange}
            >
              <SelectTrigger className="w-full font-medium">
                <SelectValue />
              </SelectTrigger>
              <SelectContent position="popper">
                <SelectGroup>
                  {options.map((item) => (
                    <SelectItem
                      className="data-[state=checked]:font-medium"
                      key={item.value}
                      value={item.value.toString()}
                      disabled={item.disabled}
                    >
                      {item.label}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          )
        },
      }}
    />
  )
}
Calendar.displayName = 'Calendar'

export { Calendar }
